import PropTypes from 'prop-types';
import React, { Fragment } from 'react';
import { List, Record } from 'immutable';
import helpers from '../../../../javascripts/helpers';

import IconRemove from '../../../../images/icons/misc/close.svg';
import IconCheck from '../../../../images/icons/misc/check.svg';

import Event from '../../../containers/betslip/Event';
import Market from '../Market';

import style from './BetFeedback.module.scss';

const BetFeedback = ({
  offer,
  handleActiveTabLink,
  unmatchedBet
}) => {
  const currencyFormatter = helpers.localise.currency;

  const matchedBets = new List(offer.matchedBets);
  const lastMatchedBet = matchedBets.last();

  const matchedBetData = {
    stake: lastMatchedBet ? lastMatchedBet.stake : offer.backersStake,
    odds: lastMatchedBet ? lastMatchedBet.odds : offer.odds,
  };

  const unmatchedBetIsMatched = unmatchedBet && unmatchedBet.status === 'matched';

  const handleTab = (tab, offerId) => {
    handleActiveTabLink(tab, offerId);
  };

  return (
    <div
      className={style.returnMessage}
      data-hook="bet-feedback"
      onClick={() => handleTab('active-bets')}
      role="button"
    >
      <div className={style.firstRow}>
        <Market
          marketName={offer.marketName}
          runnerName={offer.runnerName}
          betType={'unsubmitted'}
        />
        <Event
          eventId={offer.eventId}
          eventName={offer.eventName}
          marketId={offer.marketId}
          marketName={offer.marketName}
        />
      </div>
      {(offer.remaining > 0.001
        && (offer.matchedBets.size === 0 || offer.edited))
        && !unmatchedBetIsMatched
        && (
          <Fragment>
            <div className={style.secondRow}>
              <span className={style.betUnmatched}> Bet Unmatched</span>
              <span className={style.resume}>
                {unmatchedBet ? (
                  `${currencyFormatter(unmatchedBet.backersStake, { minimumFractionDigits: 2 })} Stake at ${Math.round(unmatchedBet.remote.odds * 100) / 100 || Math.round(unmatchedBet.odds * 100) / 100}`
                ) : (
                  `${currencyFormatter(offer.backersStake, { minimumFractionDigits: 2 })} Stake at ${Math.round(offer.remote.odds * 100) / 100 || Math.round(offer.odds * 100) / 100}`
                )}
              </span>
            </div><div className={style.feedbackSecondRow}>
              <IconRemove />
            </div>
          </Fragment>
        )}
      {unmatchedBetIsMatched && (
        <Fragment>
          <div className={style.secondRow}>
            <span className={style.betSuccesfully}> Bet Placed Succesfully</span>
            <span className={style.resume}>
              {`${currencyFormatter(unmatchedBet.backersStake, { minimumFractionDigits: 2 })} Stake at ${Math.round(unmatchedBet.remote.odds * 100) / 100 || Math.round(unmatchedBet.odds * 100) / 100}`}
            </span>
          </div>
          <div className={style.feedbackSecondRow}>
            <IconCheck />
          </div>
        </Fragment>
      )}
      {offer.remaining < 0.001 && (
        <Fragment>
          <div className={style.secondRow}>
            <span className={style.betSuccesfully}> Bet Placed Succesfully</span>
            <span className={style.resume}>
              {currencyFormatter(+matchedBetData.stake, {
                minimumFractionDigits: 2
              })} Stake at {Math.round(matchedBetData.odds * 100) / 100}
            </span>
          </div>
          <div className={style.feedbackSecondRow}>
            <IconCheck />
          </div>
        </Fragment>
      )}
      {(offer.remaining > 0.001 && (offer.matchedBets.size !== 0) && !offer.edited) && (
        <Fragment>
          <div className={style.secondRow}>
            <span className={style.betPartiallyMatched}> Bet Partially Matched</span>
            <span className={style.resume}>
              {currencyFormatter(+matchedBetData.stake, {
                minimumFractionDigits: 2
              })}  Stake at {Math.round(matchedBetData.odds * 100) / 100}
            </span>
          </div>
          <div className={style.feedbackSecondRow}>
            <IconCheck />
          </div>
        </Fragment>
      )}
    </div>
  );
};

BetFeedback.propTypes = {
  offer: PropTypes.instanceOf(Record).isRequired,
  unmatchedBet: PropTypes.instanceOf(Object),
  handleActiveTabLink: PropTypes.func,
};

export default BetFeedback;
